import axios from 'axios';
import Cookies from 'js-cookie';
import { User_EXT } from '../../Models/Classes';

export interface AuthInfo {
    UserInfo: User_EXT | null,
    SessionToken: string
}
class AuthService {
    login(email: string, password: string) {
        const apiUrl = import.meta.env.VITE_API_URL;
        return axios.post(apiUrl + 'auth/login', { email, password })
            .then(response => {
                if (response.data.code === 0) {
                    const _Token: string = response.data.data.accessToken;
                    const _User: User_EXT = response.data.data.userInfos;

                    Cookies.set('SessionToken', _Token, {
                        expires: 1,
                        secure: import.meta.env.PROD,
                        sameSite: 'Strict',
                        path: '/'
                    });

                    Cookies.set('UserInfo', JSON.stringify(_User), {
                        expires: 1,
                        secure: import.meta.env.PROD,
                        sameSite: 'Strict',
                        path: '/'
                    });
                    return response.data;
                }
            })
            .catch(error => {
                console.error("Login error:", error);
                throw error;
            });
    }

    logout() {
        Cookies.remove('SessionToken');
    }

    getCurrentUser(): AuthInfo | null {
        const SessionToken = Cookies.get('SessionToken');
        const UserInfoString = Cookies.get('UserInfo');

        if (SessionToken && UserInfoString) {
            try {
                const UserInfo = JSON.parse(UserInfoString) as User_EXT;
                return { SessionToken, UserInfo };
            } catch (error) {
                console.error("Error parsing user info:", error);
                return null;
            }
        }
        return null;
    }
}

export default new AuthService();
